import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get all responsibles.
 * 
 * @returns {Promise<Object>}
 */
export function list() {
	return axios.get(`${apiUrl}/responsible`);
}

/**
 * Create a new responsible.
 * 
 * @param {Object} params
 * @param {string} params.login
 * @param {string} params.name
 * @param {string} params.email
 * @param {string} params.profile
 * @param {string} params.gu
 * @param {string} params.positionMap
 * @returns {Promise<Object>}
 */
export function newResponsible(params) {
	return axios.post(`${apiUrl}/responsible`, params);
}

/**
 * Deactivate or Reactivate responsible by given id.
 * 
 * @param {string} id 
 * @param {string} updateField - 'N' to deactivate or 'Y' to reactivate
 * @returns {Promise<Object>}
 */
export function patchResponsible(id, updateField) {
	return axios.patch(`${apiUrl}/responsible/${id}`, updateField);
}

/**
 * Update an existing responsible's data.
 * 
 * @param {Object} params
 * @param {string} params.id
 * @param {string} params.login
 * @param {string} params.name
 * @param {string} params.email
 * @param {string} params.profile
 * @param {string} params.gu
 * @param {string} params.positionMap
 * @returns {Promise<Object>}
 */
export function updateResponsible(params) {
	return axios.put(`${apiUrl}/responsible/${params.id}`, params);
}

/**
 * Get all existing profiles from responsibles (TA, PDM, ...).
 * 
 * @returns {Promise<Object>}
 */
export function getResponsibleProfiles() {
  return axios.get(`${apiUrl}/responsible/profiles`);
}
